module.exports = __webpack_public_path__ + "img/businesswoman.f00f8829.jpg";